import {Action} from '@ngrx/store';
import {LoginAction} from '../actions/login/login-action';
import {LoginErrorAction} from '../actions/login/login-error-action';
import {LoginState} from '../states/login-state';
import {LoginSuccessAction} from '../actions/login/login-success-action';
import {Deserialize, Serialize} from 'cerialize';

const initialState = new LoginState();

export function LoginReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: LoginState = Deserialize(serializedState, LoginState);

  switch (action.type) {
    case LoginAction.type:
      state.ready = false;
      state.error = null;
      break;

    case LoginSuccessAction.type:
      state.ready = true;
      state.error = null;
      break;

    case LoginErrorAction.type:
      state.ready = true;
      state.error = (<LoginErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
